import { createContext } from 'react'

export const ReportContext = createContext({
  refScrollContainer: null,
  scrolling: false,
})
